import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, Button } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setMachineDetailsData } from '../../../redux/machineDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { CustomMultiSelect } from '../../../utils/CustomMultiSelect';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Iconify from '../../Iconify';
import { useCallback } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/machines/modifierStatut.css';

export const ModifierRisque = ({ modifyRisk, setModifyRisk }) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const machineDetailsData = useSelector((state) => state.MachineDetailsData);

    const formik = useFormik({
        initialValues: {
            risk_machine: machineDetailsData?.risk_machine?.map(risk => ({ value: risk.risk.id, label: risk.risk.name })),
        },
        validationSchema: Yup.object().shape({
            risk_machine: Yup.array().optional(),
        }),
        onSubmit: async (values) => {
            try {
                const data = {
                    risks: values.risk_machine.map(risk => risk.value),
                };
                const response = await axios.patch(`machine/machine_risks/${id}`, data);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Modifier les risques de la machine' }));
                    dispatch(setMachineDetailsData({ ...machineDetailsData, risk_machine: response.data.risk_machine }));
                    setModifyRisk(false);
                }
            } catch (error) {
                console.error('Error updating machine risques:', error);
                CustomErrorLogger(error, 'Error updating machine risques');
            }
        },
    });
    const { handleSubmit, values, setFieldValue, touched, errors } = formik;

    const fetchRisks = useCallback(async (offset, limit, search) => {
        try {
            const response = await axios.get('risk/list', {
                params: {
                    offset,
                    limit,
                    filters: { debouncedSearch: search },
                },
            });
            if (response.status === 200 || response.status === 201) {
                return response?.data?.risks?.map(risk => ({
                    value: risk.id,
                    label: risk.name,
                }));
            }
        } catch (error) {
            console.error('Error fetching risk:', error);
            CustomErrorLogger(error, "error fetching risk");
        }
    }, []);

    return (
        <Dialog open={modifyRisk} fullWidth>
            <Box onClick={() => setModifyRisk(false)} className='modifierStatut_icon_text'>
                <Typography className='modifierStatut_title'>{t('Modifier les risques de la machine')}</Typography>
                <Iconify icon={"material-symbols:close"} className='modifierStatut_close_icon' />
            </Box>
            <form onSubmit={handleSubmit}>
                <DialogContent className='modifierStatut_dialog_content'>
                    {values.errMsg && <Typography className='modifierStatut_attention_text'>{values.errMsg}</Typography>}

                    <Box className="modifierStatutDateBox">
                        <FormHelperText id="outlined-weight-helper-text" className="addSiteRelationInputTitle">{t('Risques')}</FormHelperText>
                        <CustomMultiSelect
                            placeholder='Sélectionnez des risques'
                            className='addSiteRelation_InputField'
                            required={true}
                            value={values.risk_machine}
                            fetchFunction={fetchRisks}
                            backendSearchable={true}
                            onChange={(value) => setFieldValue('risk_machine', value)}
                            helperText={touched.risk_machine && errors.risk_machine}
                            error={touched.risk_machine && Boolean(errors.risk_machine)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='modifierStatut_dialog_actions'>
                    <Button className='modifierStatut_button_annuler' onClick={() => setModifyRisk(false)}>{t('Annuler')}</Button>
                    <Button className='modifierStatut_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};